import isEmpty from "lodash/isEmpty"
import { usePromoCode } from "hooks/use-promo-code"
import { usePlanComparisonData } from "sdk/billing/queries"

export function usePlanData(initialPlans) {
  const { promoCode, promoCodeLoaded } = usePromoCode()

  const hasInitialPlans = !isEmpty(initialPlans)

  // First, usePromoCode looks for a promo code in the URL or local storage
  // Once that lookup is finished, we can decide whether to fetch plan data
  //
  // We will fetch data if:
  // - we weren't supplied with initial plans OR
  // - a promo code was found (which now needs to be applied to the plans)
  const shouldFetch =
    promoCodeLoaded && (!hasInitialPlans || Boolean(promoCode))

  const { data: fetchedData, isFetched } = usePlanComparisonData({
    promoCode,
    enabled: shouldFetch
  })

  const planData = fetchedData || initialPlans || {}

  // Initial plans render before a promo code's refetch replaces them, so
  // they only count as loaded when there's nothing left to fetch.
  const plansLoaded = promoCodeLoaded && (!shouldFetch || isFetched)

  return {
    plans: planData.plans,
    plansLoaded,
    trialing: planData.trialing,
    currentPlan: planData.current_plan,
    accountBillingState: planData.account_billing_state,
    planLimits: planData.plan_limits
  }
}
